import { unsyncedOrderNoticeByName, type UnsyncedOrderNotice } from '@d-orca/shared/client/logistics';
import { fold } from '../units';

export { unsyncedOrderNoticeByName, type UnsyncedOrderNotice };

export interface IOneOpenWiringArgs {
  inventory: { materialName: string; amount: number; unit: string }[];
  /** Receives the found level — the caller opens its edit dialog. */
  onOpenLevel: (level: { materialName: string; amount: number; unit: string }) => void;
}

/**
 * The stock dialog's one-record-per-material wiring, built per render on the
 * page. Fold-based on BOTH lookups — a refetch that respelled a name must not
 * strand the notice's "Open its record" click.
 */
export function buildTrackedWiring({ inventory, onOpenLevel }: IOneOpenWiringArgs) {
  const findLevelByName = (name: string) =>
    inventory.find((l) => fold(l.materialName) === fold(name.trim()));
  return {
    trackedByName: (name: string) => {
      const level = findLevelByName(name);
      return level ? { name: level.materialName, amount: level.amount, unit: level.unit } : null;
    },
    onOpenExisting: (name: string) => {
      const level = findLevelByName(name);
      if (level) onOpenLevel(level);
    },
  };
}
